<template>
    <div>
        <div class="content-caption dashed">
            <span>结算单信息</span>
        </div>
        <div class="simple-form flex col-3">
            <div class="form-group center">
                <div class="form-label">
                    <label>结算单号</label>
                </div>
                <div class="form-value">
                    <span>{{ settleProof.innerNo || '' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>买家公司编码</label>
                </div>
                <div class="form-value">
                    <span>{{ settleProof.buyerRealComCode || '' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>利润中心编码</label>
                </div>
                <div class="form-value">
                    <span>{{ settleProof.buyerPrftCenterCode || '' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>供方内部标识</label>
                </div>
                <div class="form-value">
                    <span>{{ settleProof.buyerInnerSellerCode }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>已开发票金额(元)</label>
                </div>
                <div class="form-value">
                    <span v-if="settleProof.invoiceAmount != null">{{ settleProof.invoiceAmount.toFixed(2) }}</span>
                    <span v-else>0.00</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>开票完毕</label>
                </div>
                <div class="form-value">
                    <span>{{ settleProof.invoiceFinished ? '是' : '否' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>结算总金额(元)</label>
                </div>
                <div class="form-value">
                    <span v-if="settleProof.settleAmount != null">{{ settleProof.settleAmount.toFixed(2) }}</span>
                    <span v-else>0.00</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>已结算金额(元)</label>
                </div>
                <div class="form-value">
                    <span v-if="settleProof.paymentAmount != null">{{ settleProof.paymentAmount.toFixed(2) }}</span>
                    <span v-else>0.00</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>未结算金额(元)</label>
                </div>
                <div class="form-value">
                    <span>{{ ((settleProof.settleAmount || 0.00) - (settleProof.paymentAmount || 0.00)).toFixed(2) }}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>发票信息</span>
            <a class="swb-btn swb-btn-mini fr"
               v-if="settleProof.settleChannelId == -1 && !settleProof.invalid && parseFloat(settleProof.settleAmount) > 0 && !settleProof.invoiceFinished && (settleProof.pullBackNo == null || settleProof.pullBackNo == '')"
               @click="applyInvoice(false)">登记发票</a>
            <!--<a class="swb-btn swb-btn-mini fr mr5" v-if="!settleProof.invalid && parseFloat(settleProof.settleAmount) > 0 && !settleProof.invoiceFinished && settleProof.tradeId != -1" @click="applyInvoice(true)">申请发票</a>-->
            <a class="swb-btn swb-btn-mini fr mr5"
               v-if="settleProof.settleChannelId == -1 && !settleProof.invalid && parseFloat(settleProof.settleAmount) > 0 && !settleProof.invoiceFinished && (settleProof.pullBackNo == null || settleProof.pullBackNo == '')"
               @click="relInvoice()">关联发票</a>
        </div>
        <el-table :data="settleInvoiceItems" border style="width: 100%">
            <el-table-column prop="actualNo" label="发票号" align="left"></el-table-column>
            <el-table-column prop="actualCode" label="发票代码" align="left"></el-table-column>
            <el-table-column prop="amount" label="含税金额(元)" width="150" align="right">
                <template slot-scope="rows">
                    <span v-if="rows.row.actualAmount != null">{{ rows.row.actualAmount.toFixed(2) }}</span>
                    <span v-else>0.00</span>
                </template>
            </el-table-column>
            <el-table-column prop="ntxAmount" label="未税金额(元)" width="150" align="right">
                <template slot-scope="rows">
                    <span v-if="rows.row.actualNtxAmount != null">{{ rows.row.actualNtxAmount.toFixed(2) }}</span>
                    <span v-else>0.00</span>
                </template>
            </el-table-column>

            <el-table-column prop="actualTaxAmount" label="税额(元)" width="150" align="right">
                <template slot-scope="rows">
                    <span v-if="rows.row.actualTaxAmount != null">{{ rows.row.actualTaxAmount.toFixed(2) }}</span>
                    <span v-else>0.00</span>
                </template>
            </el-table-column>

            <el-table-column prop="taxRate" label="税率(%)" width="150" align="right">
                <template slot-scope="rows">
                    <span v-if="rows.row.taxRate != null">{{ rows.row.taxRate.toFixed(2) }}</span>
                    <span v-else>0.00</span>
                </template>
            </el-table-column>
            <el-table-column prop="ts" label="开票日期" width="160" align="center"></el-table-column>
            <el-table-column label="操作" width="150" align="left">
                <template slot-scope="rows">
                    <span class="swb-btn swb-btn-link" @click="showInvoiceVoucher(rows.row.invoiceVoucherId)">详情</span>
                    <span class="swb-btn swb-btn-link" v-if="settleProof.applyState != 1 && settleProof.auditState != 1" @click="removeInvoiceRel(rows.row.id)">移除</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {MsgBox, Vue} from '../../app.vues'
    import {createInvoiceVoucher, showInvoiceVoucherListForSelect} from './selectDlg'

    import settleApi from '../../api/settle'
    import finacApi from '../../api/finac'
    import contractApi from '../../api/contract'

    import SwbInvoiceVoucherInfo from './InvoiceVoucherInfo';

    Vue.regist(SwbInvoiceVoucherInfo);

    export default {
        name: 'swb-settle-proof-invoice-voucher-info',
        desc: '计算单发票信息',
        props: ['settleProofId'],
        data: function () {
            return {
                settleProof: {},
                settleInvoiceItems: [],
                invoiceTypeMap: getEnumMap('invoiceType', 'value2text'),
                refresh: false
            }
        },
        created: function () {
            this.getSettleProofDetail();
        },
        methods: {
            getSettleProofDetail: function () {
                let self = this;
                let msgBoxDlg = MsgBox.loading();
                settleApi.getSettleProof(self.settleProofId, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        let settleProof = result.data || {};
                        self.settleProof = Utils.merge({}, settleProof);
                        // 获取发票
                        self.getSettleInvoiceItems();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取发票
            getSettleInvoiceItems: function () {
                let self = this;
                let postData = {
                    filterItems: {
                        proofId: self.settleProofId
                    }
                };
                settleApi.getSettleInvoiceItemList(postData, function (result) {
                    if (result.type == 'info') {
                        self.settleInvoiceItems = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 申请、登记发票
            applyInvoice: function (applyFlag) {
                let self = this;
                let row = self.settleProof || {};
                let invoiceAmount = ((row.settleAmount || 0.00) - (row.paymentAmount || 0.00)).toFixed(2);  // 未结算金额
                let params = {
                    title: applyFlag ? '申请发票' : '登记发票',
                    settleProofId: row.id,
                    invoiceAmount: invoiceAmount,
                    invoiceType: row.bizType == 2 ? null : row.invoiceType   // 20220831-基于服务工单的无发票类型，数据库保存为0，此处改为null表示支持所有发票类型的登记
                };
                createInvoiceVoucher(params, function (result, theDlg) {
                    let theLoad = MsgBox.loading();
                    let postData = result.data || {};
                    postData.relVoucherId = row.id;
                    postData.relVoucherNo = row.no;
                    postData.relVoucherInnerNo = row.innerNo;
                    postData.relVoucherType = getEnumInfoWith('srcVoucherType', 'name', 'SettleProof').value;
                    //
                    let hintMsg = postData.hintMsg;
                    if (!Utils.isNoB(hintMsg)) {
                        self.$confirm(hintMsg, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(function () {
                            finacApi.createInvoiveVoucher(postData, function (reusltInfo) {
                                theLoad.close();
                                if (reusltInfo.type == 'info') {
                                    theDlg.close();
                                    self.refresh = true;
                                    MsgBox.success('登记成功');
                                    self.getSettleProofDetail();
                                } else {
                                    MsgBox.warning(reusltInfo.message);
                                }
                            });
                        }).catch(function () {
                            theLoad.close();
                        });
                    } else {
                        finacApi.createInvoiveVoucher(postData, function (reusltInfo) {
                            theLoad.close();
                            if (reusltInfo.type == 'info') {
                                theDlg.close();
                                self.refresh = true;
                                MsgBox.success('登记成功');
                                self.getSettleProofDetail();
                            } else {
                                MsgBox.warning(reusltInfo.message);
                            }
                        });
                    }
                });
            },
            // 关联发票
            relInvoice: function () {
                let self = this;
                let row = self.settleProof || {};
                let params = {
                    buyerRealComCode: row.buyerRealComCode,
                    settleProofId: row.id,
                    invoiceType: row.bizType == 2 ? null : row.invoiceType   // 20220831-基于服务工单的无发票类型，数据库保存为0，此处改为null表示支持所有发票类型的登记
                };
                showInvoiceVoucherListForSelect(params, function (resultData, theDlg) {
                    //
                    let resultDataList = resultData || [];
                    let invoiceVoucherIds = resultDataList.pluck('id') || [];
                    //
                    let contractId = row.contractId;
                    if (!Utils.isNoB(contractId) && contractId > 0) {
                        let contractData = {};
                        contractData.id = contractId;
                        //
                        let lastMsgBoxDlg = MsgBox.loading();
                        contractApi.getContractInfo(contractData, function (result) {
                            lastMsgBoxDlg.close();
                            if (result.type == 'info') {
                                let contranct = result.data || {};
                                //
                                let invoiceType = contranct.invoiceType || null;
                                let invoiceTitle = contranct.invoiceTitle || null;
                                let invoiceContentTag = contranct.invoiceContentTag || null;
                                let buyerTaxPayerNo = contranct.taxPayerNo || null;
                                let needHint = false;
                                for (let i = 0; i < resultDataList.length; i++) {
                                    let invoiceVoucher = resultDataList[i];
                                    if (!Utils.isNoB(invoiceType) && invoiceType != invoiceVoucher.invoiceType) {
                                        needHint = true;
                                    }
                                    if (!Utils.isNoB(invoiceTitle) && invoiceTitle != invoiceVoucher.invoiceTitle) {
                                        needHint = true;
                                    }
                                    if (!Utils.isNoB(invoiceContentTag) && invoiceContentTag != invoiceVoucher.invoiceContentTag) {
                                        needHint = true;
                                    }
                                    if (!Utils.isNoB(buyerTaxPayerNo) && buyerTaxPayerNo != invoiceVoucher.buyerTaxPayerNo) {
                                        needHint = true;
                                    }
                                }
                                if (Utils.isTrue(needHint)) {
                                    let hintMsg = '您好！您所关联的发票与签订合同中的发票信息不一致，请您再次确认是否使用该发票！';
                                    self.$confirm(hintMsg, '提示', {
                                        confirmButtonText: '确定',
                                        cancelButtonText: '取消',
                                        type: 'warning'
                                    }).then(function () {
                                        theDlg.close();
                                        //
                                        let postData = {};
                                        postData.invoiceVoucherIds = invoiceVoucherIds;
                                        postData.settleProofId = row.id || null;
                                        let theLoad = MsgBox.loading();
                                        settleApi.doSettleProofRelInvoiceVoucher(postData, function (result) {
                                            theLoad.hide();
                                            if (result.type == 'info') {
                                                self.refresh = true;
                                                MsgBox.success('关联成功');
                                                //
                                                self.getSettleProofDetail();
                                            } else {
                                                MsgBox.warning(result.message);
                                            }
                                        });
                                    }).catch(function () {
                                    });
                                } else {
                                    theDlg.close();
                                    //
                                    let postData = {};
                                    postData.invoiceVoucherIds = invoiceVoucherIds;
                                    postData.settleProofId = row.id || null;
                                    let theLoad = MsgBox.loading();
                                    settleApi.doSettleProofRelInvoiceVoucher(postData, function (result) {
                                        theLoad.hide();
                                        if (result.type == 'info') {
                                            self.refresh = true;
                                            MsgBox.success('关联成功');
                                            //
                                            self.getSettleProofDetail();
                                        } else {
                                            MsgBox.warning(result.message);
                                        }
                                    });
                                }
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    } else {
                        theDlg.close();
                        //
                        let postData = {};
                        postData.invoiceVoucherIds = invoiceVoucherIds;
                        postData.settleProofId = row.id || null;
                        let theLoad = MsgBox.loading();
                        settleApi.doSettleProofRelInvoiceVoucher(postData, function (result) {
                            theLoad.hide();
                            if (result.type == 'info') {
                                self.refresh = true;
                                MsgBox.success('关联成功');
                                //
                                self.getSettleProofDetail();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }
                });
            },
            // 移除操作
            removeInvoiceRel: function (id) {
                let self = this;
                self.$confirm('确定要移除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let msgBoxDlg = MsgBox.loading();
                    let postData = {
                        id: id,
                    };
                    settleApi.updateSettleInvoiceItemForRemove(postData, function (result) {
                        msgBoxDlg.close();
                        if (result.type == 'info') {
                            self.refresh = true;
                            MsgBox.success('操作成功');
                            //
                            self.getSettleProofDetail();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },
            // 发票详情
            showInvoiceVoucher: function (id) {
                let theDlg = Vue.$showDialog({
                    title: '发票单据 - 详情',
                    showCloseBtn: true,
                    okVisible: false,
                    cancelText: '关闭',
                    width: 1000,
                    height: -60,
                    template: '<swb-invoice-voucher-info :id="id"></swb-invoice-voucher-info>',
                    data: {
                        id: id
                    },
                    methods: {},
                    okClicked: function () {
                        theDlg.close();
                    }
                });
            },
            getDlgResult: function () {
                let result = {};
                result.type = 'info';
                result.data = this.refresh;
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/invoiceVoucher/SettltProofInvoiceVoucherInfo.vue